import React from "react";
import { Avatar } from "antd";
import { compose } from "recompose";
import { withTranslation } from "react-i18next";

import { getOptimizedImage } from "../../../utils/images";
import BrowserLayout from "../../../components/BrowserLayout";

import styled from "styled-components/macro";

const Header = styled.div`
  background-color: ${props => props.backgroundColor};
  height: 60px;
  display: flex;
  align-items: center;
  padding: 0 50px;

  .ant-avatar {
    margin-right: 16px;
  }
`;

const CompanyName = styled.h2`
  font-size: 25px;
  color: ${props => props.color};
  margin: 0;
`;

const Positions = styled.div`
  background-color: ${props => props.backgroundColor};
  height: 300px;
  overflow: hidden;
  border-radius: 0 0 5px 5px;
  padding: 24px 50px 0 50px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 16px;
  border: 1px solid rgba(0, 0, 0, 0.05);
  border-top: none;
`;

const PositionCard = styled.div`
  height: 190px;
  background-color: white;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.15);
  border-radius: 4px;
`;

const SitePreview = ({
  companyURL,
  bodyBackgroundColor,
  headerFontColor,
  headerBackgroundColor,
  headerLogo,
  title
}) => {
  return (
    <BrowserLayout url={companyURL}>
      <Header backgroundColor={headerBackgroundColor}>
        <Avatar
          size={40}
          shape="square"
          src={getOptimizedImage(headerLogo)}
          icon="shop"
        />
        <CompanyName color={headerFontColor}>{title}</CompanyName>
      </Header>
      <Positions backgroundColor={bodyBackgroundColor}>
        <PositionCard />
        <PositionCard />
        <PositionCard />
        <PositionCard />
        <PositionCard />
        <PositionCard />
      </Positions>
    </BrowserLayout>
  );
};

const enhancer = compose(withTranslation(["company"]));

export default enhancer(SitePreview);
